import { useEffect, useState, Fragment } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import Moment from "react-moment";
import Defaultimg from "../../assets/Frame.png";
import { useTranslation } from "react-i18next";
import {
  fetchgetsingleowner,
  STATUSES,
} from "../../redux/getReducer/getSingleOwner";
import { fetchOwnerHistory } from "../../redux/getReducer/getSingleOwnerHistory";
import { useDispatch, useSelector } from "react-redux";
import PleaseWait from "../../Components/Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import Stats from "../Tabs/OwnerStats";
import HorseOwnerStats from "../Tabs/HorseOwnerStats";
import HorseKindOwnerStats from "../Tabs/HorseKindOwnerStats";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VideoFrame from "./VideoFrame";
import OwnerEntries from "../Tabs/OwnerEntries";
import JockeyDetail from "./JockeyModal";
import HorseModal from "./HorseModal";
import RaceModal from "./RaceModal";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import Pagination from "../../pages/Pagination";
import { fetchownerhorsekindStats } from "../../redux/getReducer/getOwnerHorseKind";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import ScrollContainer from "react-indiana-drag-scroll";
import NoHistory from "../../Components/Reuseable/NoHistory.jsx";

import { getBaseUrl } from "../../service/apiUrl";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";
// import "./OwnerDetailNew.css"; 

const OwnerDetail = (data) => {
  // --- ALL ORIGINAL STYLES PRESERVED ---
  const btnNew2 = { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "13px 10px", gap: "10px", width: "112px", height: "24px", background: "#0388fc", borderRadius: "10px", border: "none", color: "#fff", margin: "6px" };
  const btnNew1 = { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "13px 10px", gap: "10px", width: "112px", height: "24px", background: "#FF0000", borderRadius: "10px", border: "none", color: "#fff", margin: "6px" };

  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };

  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const handleHorseCloses = () => setShowHorse(false);
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  const handleShowJockey = (data) => {
    const jId = data?._id || data;
    if (jId) navigate("/jockey-detail?" + jId);
  };

  let id = data.data.OwnerOnRaceData1 ? data.data.OwnerOnRaceData1._id : data.data._id ? data.data._id : data.data;

  const { data: getsingleowner, status } = useSelector((state) => state.getsingleowner);
  const { data: OwnerHistory, status: historyStatus } = useSelector((state) => state.OwnerHistory);

  // Pagination Logic Preserved
  const sortedOwnerHistory = (OwnerHistory || []).slice().sort((a, b) => {
    const dateA = new Date(a?.RaceResultData?.Day || a?.RaceResultData?.StartTime || a?.Day || 0).getTime();
    const dateB = new Date(b?.RaceResultData?.Day || b?.RaceResultData?.StartTime || b?.Day || 0).getTime();
    return dateB - dateA;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  let totalcountdata = sortedOwnerHistory.length;
  const totalpagesdata = Math.ceil(totalcountdata / postsPerPage);
  const firstPageIndex = (currentPage - 1) * postsPerPage;
  const lastPageIndex = firstPageIndex + postsPerPage;
  const SliceData = sortedOwnerHistory.slice(firstPageIndex, lastPageIndex);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowRace = (rId) => {
    if (rId) navigate("/race-detail?" + rId);
  };

  const handleUnTrack = async (Id) => {
    try {
      await axios.post(`${getBaseUrl()}/UnTrackOwner`, { Owner: Id }, { headers: { Authorization: token, "x-xsrf-token": token } });
      toast("Owner Has Been UnTracked");
      navigate("/tracker/#Ownercontact");
    } catch (error) { const err = error.response.data.message; toast(err); }
  };

  useEffect(() => {
    dispatch(fetchgetsingleowner({ id }));
    dispatch(fetchOwnerHistory({ id }));
  }, [dispatch, id]);

  const handleTrack = async (Id) => {
    try {
      await axios.post(`${getBaseUrl()}/trackowner`, { Owner: Id }, { headers: { Authorization: token, "x-xsrf-token": token } });
      navigate("/tracker/#Ownercontact");
    } catch (error) {
      const err = error.response.data.message;
      if (err === "Json Web Token is invalid") { toast.error("Please Login to Access This Resource"); navigate("/login"); } else { toast.error(err); }
    }
  };

  function calculatePercentage(x, y) {
    if (x === 0 && y === 0) return 0;
    return Math.round((x / y) * 100);
  }

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    else if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (d.toFixed(2) == 0.10 && rank < 80) return "Hd";
    else if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (d.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }

  const handleHorseKind = (tabIndex) => {
    if (tabIndex == "HorseKind") { dispatch(fetchownerhorsekindStats({ id })); }
  };

  return (
    <div className="owner-new-master-wrapper">
      {status === "loading" ? (
        <Lottie animationData={Animate} loop={true} style={{ width: 150, margin: 'auto' }} />
      ) : (
        <div className="owner-new-page-content">

          {/* --- TOP SECTION: Red Box 1 --- */}
          <div className="owner-new-profile-header">
            <div className="owner-new-left-side">
              <div className="owner-new-img-box">
                <img
                  src={data?.data?.OwnerSilkColor || data?.data?.image || getsingleowner?.image || Defaultimg}
                  alt="Owner"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = Defaultimg;
                  }}
                />
              </div>
              <div className="owner-new-info-content">
                {/* Column 1: Identity */}
                <div className="owner-new-main-details">
                  <h3 className="owner-new-name">{cookiedata === "en" ? getsingleowner?.NameEn : getsingleowner?.NameAr}</h3>
                  <p className="owner-new-stats-row">
                    {getsingleowner?.TotalCount || "0"} ({getsingleowner?.TotalWins || "0"}-{getsingleowner?.Totalsecond || "0"}-{getsingleowner?.Totalthird || "0"})
                  </p>
                </div>
              </div>
            </div>
            <div className="owner-new-right-side">
              {getsingleowner?.track ? (
                <button className="owner-new-btn-untrack" onClick={() => handleUnTrack(getsingleowner._id)}>{t("Untrack")}</button>
              ) : (
                <button className="owner-new-btn-track" onClick={() => handleTrack(getsingleowner._id)}>{t("Track")}</button>
              )}
            </div>
          </div>

          {/* --- MIDDLE SECTION: Red Box 2 (Lifetime Record) --- */}
          <div className="owner-new-middle-grid">
            <div className="owner-new-grid-thead">
              <div>{t("Lifetime Record")}</div><div>{t("Runs")}</div><div>{t("Wins")}</div><div>{t("2nd")}</div><div>{t("3rd")}</div><div>{t("4th")}</div><div>{t("5th")}</div><div>{t("Winnings")}</div><div>{t("Earnings")}</div>
            </div>
            <div className="owner-new-grid-tbody">
              {/* Flat Turf Row */}
              <div className="owner-new-grid-row">
                <div className="new-bold">{t("Flat Turf")}</div>
                <div>{getsingleowner.TurfCount}</div>
                <div>{getsingleowner.TurfWins === null ? 0 : getsingleowner.TurfWins}</div>
                <div>{getsingleowner.Turfsecond === null ? 0 : getsingleowner.Turfsecond}</div>
                <div>{getsingleowner.Turfthird === null ? 0 : getsingleowner.Turfthird}</div>
                <div>{getsingleowner.Turffourth === null ? 0 : getsingleowner.Turffourth}</div>
                <div>{getsingleowner.Turffifth === null ? 0 : getsingleowner.Turffifth}</div>
                <div>{calculatePercentage((getsingleowner.Turfsecond || 0) + (getsingleowner.TurfWins || 0) + (getsingleowner.Turfthird || 0), getsingleowner.TurfCount)}%</div>
                <div>{Number(getsingleowner.TurfEarnings === null ? 0 : getsingleowner.TurfEarnings).toLocaleString()}</div>
              </div>
              {/* Dirt Row */}
              <div className="owner-new-grid-row">
                <div className="new-bold">{t("Dirt")}</div>
                <div>{getsingleowner.DirtCount}</div>
                <div>{getsingleowner.DirtWins === null ? 0 : getsingleowner.DirtWins}</div>
                <div>{getsingleowner.Dirtsecond === null ? 0 : getsingleowner.Dirtsecond}</div>
                <div>{getsingleowner.Dirtthird === null ? 0 : getsingleowner.Dirtthird}</div>
                <div>{getsingleowner.Dirtfourth === null ? 0 : getsingleowner.Dirtfourth}</div>
                <div>{getsingleowner.Dirtfifth === null ? 0 : getsingleowner.Dirtfifth}</div>
                <div>{calculatePercentage((getsingleowner.Dirtsecond || 0) + (getsingleowner.DirtWins || 0) + (getsingleowner.Dirtthird || 0), getsingleowner.DirtCount)}%</div>
                <div>{Number(getsingleowner.DirtEarnings === null ? 0 : getsingleowner.DirtEarnings).toLocaleString()}</div>
              </div>
              {/* All Weather Row */}
              <div className="owner-new-grid-row">
                <div className="new-bold">{t("All Weather")}</div>
                <div>{getsingleowner.AllWeatherCount}</div>
                <div>{getsingleowner.AllWeatherWins === null ? 0 : getsingleowner.AllWeatherWins}</div>
                <div>{getsingleowner.AllWeathersecond === null ? 0 : getsingleowner.AllWeathersecond}</div>
                <div>{getsingleowner.AllWeatherthird === null ? 0 : getsingleowner.AllWeatherthird}</div>
                <div>{getsingleowner.AllWeatherfourth === null ? 0 : getsingleowner.AllWeatherfourth}</div>
                <div>{getsingleowner.AllWeatherfifth === null ? 0 : getsingleowner.AllWeatherfifth}</div>
                <div>{calculatePercentage((getsingleowner.AllWeathersecond || 0) + (getsingleowner.AllWeatherWins || 0) + (getsingleowner.AllWeatherthird || 0), getsingleowner.AllWeatherCount)}%</div>
                <div>{Number(getsingleowner.AllWeatherEarnings === null ? 0 : getsingleowner.AllWeatherEarnings).toLocaleString()}</div>
              </div>
              {/* Total Highlighted Row */}
              <div className="owner-new-grid-row owner-new-total-highlight">
                <div className="new-bold">{t("Total")}</div>
                <div>{getsingleowner.TotalCount}</div>
                <div>{getsingleowner.TotalWins === null ? 0 : getsingleowner.TotalWins}</div>
                <div>{getsingleowner.Totalsecond === null ? 0 : getsingleowner.Totalsecond}</div>
                <div>{getsingleowner.Totalthird === null ? 0 : getsingleowner.Totalthird}</div>
                <div>{getsingleowner.Totalfourth === null ? 0 : getsingleowner.Totalfourth}</div>
                <div>{getsingleowner.Totalfifth === null ? 0 : getsingleowner.Totalfifth}</div>
                <div>{calculatePercentage((getsingleowner.Totalsecond || 0) + (getsingleowner.TotalWins || 0) + (getsingleowner.Totalthird || 0), getsingleowner.TotalCount)}%</div>
                <div className="new-bold">{Number(getsingleowner.TotalEarnings === null ? 0 : getsingleowner.TotalEarnings).toLocaleString()}</div>
              </div>
            </div>
          </div>

          {/* --- BOTTOM SECTION: Red Box 3 (Tabs & Details) --- */}
          <div className="owner-new-tabs-container">
            <Tabs id="owner-tabs" className="owner-new-styled-tabs mb-4" onSelect={handleHorseKind} defaultActiveKey="Form">
              <Tab eventKey="Form" title={t("Form")}>
                <div className="owner-new-tab-content">
                  <ScrollContainer className="owner-new-scroll-box">
                    <div className="owner-new-16col-table">
                      <div className="owner-new-thead-16">
                        <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("Speed")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("W Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
                      </div>
                      <div className="owner-new-tbody-16">
                        {(!OwnerHistory || historyStatus === "loading") ? (
                          <div className="text-center py-4"><PleaseWait /></div>
                        ) : (!SliceData || SliceData.length === 0) ? (
                          <div className="text-center py-4"><NoHistory /></div>
                        ) : SliceData.map((item, idx) => {
                          const ground = item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                          const rowColor = ground === "Turf" ? "#d4edda" : ground === "Dirt" ? "#f2e6d9" : "#f1f5f9";
                          return (
                            <div key={idx} className="owner-new-row-16" style={{ backgroundColor: rowColor, color: '#343433' }}>
                              <div onClick={() => handleShowRace(item.RaceID)} className="owner-new-link-white"><Moment format="DD/MM/YYYY">{item.RaceResultData?.Day || item.RaceResultData?.StartTime}</Moment></div>
                              <div>
                                {cookiedata === "en" ? (item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn) : (item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevAr)}
                                ({cookiedata === "en" ? ground?.charAt(0) : item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})
                              </div>
                              <div className="owner-new-link-white" onClick={() => handleShowHorse(item?.HorseIDData?._id)}>
                                {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
                              </div>
                              <div>{item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                              <div className="owner-new-truncate">{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameAr}</div>
                              <div>{item.RaceTime}</div>
                              <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult?._id)} className="owner-new-link-white">{cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}</div>
                              <div>{item.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight}</div>
                              <div>{typeof item.Speed === "number" ? item.Speed.toFixed(2) : "-"}</div>
                              <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
                              <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                              <div>{item.Runners}</div>
                              {(() => {
                                const rank = item?.FinalPositionDataHorse?.Rank;
                                const targetHorse = rank === 1
                                  ? (item?.RunnerUpData || item?.BeatenByData || null)
                                  : (item?.WinnerData || item?.BeatenByData || null);
                                const targetName = targetHorse
                                  ? (cookiedata === "en" ? toTitleCase(targetHorse.NameEn || "") : (targetHorse.NameAr || targetHorse.NameEn || "-"))
                                  : (cookiedata === "en"
                                      ? toTitleCase(item?.HorseIDData?.HorseBeatenByEnglishName || "")
                                      : (item?.HorseIDData?.HorseBeatenByArabicName || item?.HorseIDData?.HorseBeatenByEnglishName || "-"));
                                const targetId = targetHorse?._id || item?.BeatenByData?._id;
                                const targetWeight = targetHorse?.WinningHorseJockeyWeight ?? item?.BeatenByData?.WinningHorseJockeyWeight ?? item?.HorseIDData?.BeatenByJockeyWeight ?? 0;

                                return (
                                  <>
                                    <div
                                      className={`owner-new-truncate ${targetId ? "owner-new-link-white" : ""}`}
                                      title={targetName || ""}
                                      onClick={() => targetId && handleShowHorse(targetId)}
                                      style={{ cursor: targetId ? "pointer" : "default" }}
                                    >
                                      {targetName || "-"}
                                    </div>
                                    <div>{targetWeight}</div>
                                  </>
                                );
                              })()}
                              <div>{item.RaceResultData?.RacehorsesData?.[0]?.HorseNo || "-"}</div>
                              <div>{item.Rating || 0}</div>
                              <div onClick={() => handleShows(item.VideoLink)} className="owner-new-mini-play"><IoMdPlay /></div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </ScrollContainer>
                  <div className="owner-new-pagination-wrapper">
                    <Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} />
                  </div>
                </div>
              </Tab>
              <Tab eventKey="Entries" title={t("Entries")}><OwnerEntries id={id} /></Tab>
              <Tab eventKey="Horses" title={t("Horses")}><div className="RaceAndHorseModelDataCSS"><HorseOwnerStats id={id} /></div></Tab>
              <Tab eventKey="HorseKind" title={t("Horse Kind")}><div className="RaceAndHorseModelDataCSS"><HorseKindOwnerStats id={id} /></div></Tab>
              <Tab eventKey="Stats" title={t("Stats")}><div className="RaceAndHorseModelDataCSS"><Stats id={id} /></div></Tab>
            </Tabs>
          </div>
        </div>
      )}

      {/* --- ALL MODALS PRESERVED --- */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
    </div>
  );
};

export default OwnerDetail;